export const NATIONAL_INSURANCE_NUMBER_STEP = 'NATIONAL_INSURANCE_NUMBER';
export const SIGNATURE_STEP = 'SIGNATURE';
export const MOBILE_NUMBER_STEP = 'MOBILE_NUMBER';
export const CURRENT_ADDRESS_STEP = 'CURRENT_ADDRESS';
export const ADDRESS_HISTORY_STEP = 'ADDRESS_HISTORY';
export const ADD_A_PREVIOUS_ADDRESS_STEP = 'ADD_A_PREVIOUS_ADDRESS';
export const CONFIRM_ADDRESS_STEP = 'CONFIRM_ADDRESS';
export const THANK_YOU_STEP = 'THANK_YOU';
